<template>
  <div class="row">
    <div class="col-lg-12 mb-20">
      <div class="input-group search">
        <input v-model="search.title" type="text" placeholder="search projects" class="form-control"/>
          <span class="input-group-btn">
            <button type="button" @click="setSearch()" class="btn btn-default">
              <span aria-hidden="true" class="glyphicon glyphicon-search"></span>
            </button>
          </span>
        </input>
      </div>
    </div>
    <div class="col-md-4">
      <div class="btn-group">
        <button type="button" class="btn btn-default dropdown-toggle button-filter" data-toggle="dropdown"
                aria-haspopup="true" aria-expanded="false">
          {{ search.category || $t("category") }}<span class="caret"></span>
        </button>
        <ul class="dropdown-menu">
          <li @click="categorySearch({ id: null, name: null })">
            <a>{{ $t("category") }}</a>
          </li>
          <li v-for="category in categories" @click="categorySearch(category)">
            <a>{{ category.name }}</a>
          </li>
        </ul>
      </div>
    </div><!-- .col-md-4 -->
    <div class="col-md-4">
      <div class="btn-group" :class="location_dropdown">
        <button type="button" class="btn btn-default dropdown-toggle button-filter" data-toggle="dropdown"
                aria-haspopup="true" aria-expanded="false">
          {{ $t("location") }}<span class="caret"></span>
        </button>
        <div class="dropdown-menu location">
          <div class="form-group mt-20">
            <input v-model="search.city" class="form-control" :placeholder="$t('city')">
          </div>
          <div class="form-group mt-20">
            <select v-if="countries.length" v-model="search.country_id" class="form-control" @change="show_location_dropdown()">
              <option disabled value="">{{ $t("country") }}</option>
              <option v-for="country in countries" :value="country.id">{{ country.name }}</option>
            </select>
          </div>
          <button @click="setSearch()" class="btn btn-default btn-lg button-wide">{{ $t("find") }}</button>
        </div>
      </div><!-- .btn-group -->
    </div><!-- .col-md-4 -->
    <div class="col-md-4">
      <div class="btn-group">
        <button type="button" class="btn btn-default dropdown-toggle button-filter" data-toggle="dropdown"
                aria-haspopup="true" aria-expanded="false">
          {{ $t("project.search.all") }}<span class="caret"></span>
        </button>
        <ul class="dropdown-menu">
          <li @click="statusSearch({ status: null })"><a>{{ $t("project.search.all") }}</a></li>
          <li @click="statusSearch({ status: 'popular' })"><a>{{ $t("project.search.trendingStatus") }}</a></li>
          <li @click="statusSearch({ status: 'little_missing' })"><a>{{ $t("project.search.littleMissing") }}</a></li>
          <li @click="statusSearch({ status: 'ending' })"><a>{{ $t("project.search.almostFinished") }}</a></li>
        </ul>
      </div><!-- .btn-group -->
    </div><!-- .col-md-4 -->
  </div><!-- .row -->
</template>

<script>
import dictionariesApi from '@/api/v1/shared/dictionaries';

export default {
  props: ['categories', 'type'],
  data() {
    return {
      countries: [],
      location_dropdown: 'none',
    };
  },
  computed: {
    search() {
      return {
        category_id: this.$route.query.category_id,
        category: this.$route.query.category,
        country_id: this.$route.query.country_id || '',
        title: this.$route.query.title,
        city: this.$route.query.city,
        status: this.$route.query.status,
      };
    },
  },
  methods: {
    setSearch() {
      this.refineSearchParams();
      this.$router.push({ name: this.type, query: this.search });
      this.search.crowdfunding = true;
    },
    categorySearch(category) {
      this.search.category = category.name;
      this.search.category_id = category.id;
      this.refineSearchParams();
      this.$router.push({ name: this.type, query: this.search });
    },
    statusSearch(statuses) {
      this.search.status = statuses.status;
      this.refineSearchParams();
      this.$router.push({ name: this.type, query: this.search });
    },
    // Remove empty params from search query
    refineSearchParams() {
      const vm = this;
      Object.keys(this.search).forEach((key) => {
        if (!vm.search[key]) delete vm.search[key];
      });
    },
    show_location_dropdown() {
      this.location_dropdown = 'open';
    },
    hide_location_dropdown(e) {
      if (e.target.className === 'form-control') {
        e.stopPropagation();
      } else if (this.location_dropdown === 'open') {
        this.location_dropdown = null;
      }
    },
  },
  created() {
    dictionariesApi.getCountries((countries) => {
      this.countries = countries;
      this.countries.unshift({ name: this.$t('none'), id: null });
    });
  },
  mounted() {
    document.body.addEventListener('click', (e) => { this.hide_location_dropdown(e); });
  },
};
</script>



// WEBPACK FOOTER //
// Search.vue?103fe842